import { DIRECT_CHAT_ROOM } from "@circle-react/components/constants";
import { useLocation, useNavigate } from "@tanstack/react-router";
import { useState } from "react";

import { usePunditUserContext } from "@/react/contexts/punditUserContext";
import { chatRoomLinkOptions } from "@/react/helpers/urlHelpers";
import { useChatUIStore } from "@/react/hooks/chatsV2/store";
import { useChatRoom } from "@/react/hooks/chatsV2/useChatRoom";
import { usePreviousLocationState } from "@/react/hooks/usePreviousLocationState";

export const useSendMessageToUser = () => {
  const { findOrCreateChatRoom } = useChatRoom();
  const { isViewOnlyMasquerading } = usePunditUserContext();

  const pathname = useLocation({ select: location => location.pathname });
  const navigate = useNavigate();
  const { setLiveChatRoomUuid } = useChatUIStore();
  const previousLocationState = usePreviousLocationState();

  const [isLoading, setIsLoading] = useState(false);

  const handleMessageMember = async (memberId: string) => {
    if (isViewOnlyMasquerading) {
      return;
    }
    setIsLoading(true);
    const chatRoomUuid = (await findOrCreateChatRoom({
      kind: DIRECT_CHAT_ROOM,
      community_member_ids: [memberId],
    })) as string | null;

    if (!chatRoomUuid) {
      return;
    }
    const isLiveStream = pathname.includes("/live");
    if (isLiveStream) {
      setLiveChatRoomUuid(chatRoomUuid);
      return;
    }
    setIsLoading(false);
    void navigate({
      ...chatRoomLinkOptions({ uuid: chatRoomUuid }),
      state: previousLocationState,
    });
  };

  return {
    handleMessageMember,
    isLoading,
  };
};
